module.exports = __webpack_public_path__ + "static/media/trainPathFileImportTemp.097f9bc9.xlsx";